import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1fcb3396: FaireBrandEntity = {
  token: "b_1fcb3396",
  type: "brand",
  name: "Dear Hancock",
  avatarUrl:
    "https://cdn.faire.com/fastly/aa46b6c97e1d855409c2c24214e873a6ad74bcf0252b32046a38cf54645f11e3.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/67b67d19eebb8b5b08cc6ba631bfe80952e2ab726fa9d456c7864f882171d0d3.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/aa46b6c97e1d855409c2c24214e873a6ad74bcf0252b32046a38cf54645f11e3.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/67b67d19eebb8b5b08cc6ba631bfe80952e2ab726fa9d456c7864f882171d0d3.jpeg",
  location: "Richmond, VA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 85,
  isTopShop: true,
  isInsider: true,
  description:
    "\nWendy Mason and Earnest Merritt, wife and husband duo, formed Dear Hancock in 2010 as a way to share their love of painting, drawing, and paper goods. Dear Hancock’s painterly aesthetics and narrative details represent a mix of nostalgia, humor, and everyday life. Mason’s and Merritt’s art backgrounds are visible in this unique brand, including Hancock the Punny Rabbit, a beloved character who is depicted hopping around humorous situations with a steadfast expression.\n\nAll Dear Hancock paper goods are printed on recyclable, FSC approved, green-e certified soft white paper stock. The 100% recycled kraft envelopes come from a hydro-electric paper mill and all Dear Hancock paper goods are printed in the USA. Dear Hancock operates out of a beautiful vintage schoolhouse in Richmond, VA.\n\nWendy and Earnest met at Cal Arts where they earned their MFA degrees. The pair formed Dear Hancock in Los Angeles, CA in 2010. To learn more about us you can also visit our website https://www.dearhancock.com\n ‪‪❤︎‬\n\n\n\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:43.805Z",
    importedBy: "entity-db-cli",
  },
};
